export default {
  getCurrentApplication: (state) => state.application,
}
